<yes-no
  [title]="'Hoogwerker'"
  [value]="externalSupplierAware.extraHoogwerker"
  [nullable]="true"
  [nullIsFalse]="false"
  [inputText]="externalSupplierAware.extraHoogwerkerDescription"
  [done]="externalSupplierAware.extraHoogwerkerDone"
  [extraInstructions]="'Type hoogwerker, ...'"
  (answer)="extraHoogwerkerChange($event)"
  (answeredText)="extraHoogwerkerTextChange($event)"
  (doneAnswered)="extraHoogwerkerDoneChange($event)"
>
</yes-no>

<div
  *ngIf="externalSupplierAware.extraHoogwerker"
  class="d-flex external-supplier-employee-date"
>
  <div>
    <div class="form-sub-title">Medewerker</div>

    <mat-form-field class="" appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        name="hoogwerkerEmployee"
        required
        [(ngModel)]="externalSupplierAware.extraHoogwerkerEmployee"
        (ngModelChange)="extraHoogwerkerEmployeeChange()"
        [compareWith]="compareEntities"
      >
        <mat-option *ngFor="let option of employeeChoices" [value]="option">
          {{ option.user.firstName }} {{ option.user.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="left-space">
    <div class="form-sub-title">Deadline</div>
    <mat-form-field appearance="outline">
      <input
        #extraHoogwerkerDeadlineInput
        matInput
        [matDatepicker]="extraHoogwerkerDeadlinePicker"
        placeholder="Selecteer een datum"
        [value]="externalSupplierAware.extraHoogwerkerDeadline"
        (dateChange)="extraHoogwerkerDeadlineChange($event)"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="extraHoogwerkerDeadlinePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #extraHoogwerkerDeadlinePicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>

<yes-no
  [title]="'Parkeerverbod'"
  [value]="externalSupplierAware.parkingBan"
  [nullable]="true"
  [nullIsFalse]="false"
  [inputText]="externalSupplierAware.extraInfoParkingBan"
  [done]="externalSupplierAware.parkingBanDone"
  (answer)="parkingBanChange($event)"
  (answeredText)="extraInfoParkingBanChange($event)"
  (doneAnswered)="parkingBanDoneChange($event)"
></yes-no>

<div
  *ngIf="externalSupplierAware.parkingBan"
  class="d-flex external-supplier-employee-date"
>
  <div>
    <div class="form-sub-title">Medewerker</div>

    <mat-form-field class="" appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        name="parkingBanEmployee"
        required
        [(ngModel)]="externalSupplierAware.parkingBanEmployee"
        (ngModelChange)="parkingBanEmployeeChange()"
        [compareWith]="compareEntities"
      >
        <mat-option *ngFor="let option of employeeChoices" [value]="option">
          {{ option.user.firstName }} {{ option.user.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="left-space">
    <div class="form-sub-title">Deadline</div>
    <mat-form-field appearance="outline">
      <input
        #parkingBanDeadlineInput
        matInput
        [matDatepicker]="parkingBanDeadlinePicker"
        placeholder="Selecteer een datum"
        [value]="externalSupplierAware.parkingBanDeadline"
        (dateChange)="parkingBanDeadlineChange($event)"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="parkingBanDeadlinePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #parkingBanDeadlinePicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>

<yes-no
  [title]="'Extra leverancier nodig'"
  [value]="externalSupplierAware.needExtraSupplier"
  [nullable]="true"
  [nullIsFalse]="false"
  [done]="externalSupplierAware.needExtraSupplierDone"
  [inputText]="externalSupplierAware.extraInfoNeedExtraSupplier"
  [extraInstructions]="'Geef meer informatie aub'"
  (answer)="needExtraSupplierChange($event)"
  (answeredText)="extraInfoNeedExtraSupplierChange($event)"
  (doneAnswered)="needExtraSupplierDoneChange($event)"
>
</yes-no>

<div
  *ngIf="externalSupplierAware.needExtraSupplier"
  class="d-flex external-supplier-employee-date"
>
  <div>
    <div class="form-sub-title">Medewerker</div>

    <mat-form-field class="" appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        name="extraSupplierEmployee"
        required
        [(ngModel)]="externalSupplierAware.extraSupplierEmployee"
        (ngModelChange)="extraSupplierEmployeeChange()"
        [compareWith]="compareEntities"
      >
        <mat-option *ngFor="let option of employeeChoices" [value]="option">
          {{ option.user.firstName }} {{ option.user.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="left-space">
    <div class="form-sub-title">Deadline</div>
    <mat-form-field appearance="outline">
      <input
        #extraSupplierDeadlineInput
        matInput
        [matDatepicker]="extraSupplierDeadlinePicker"
        placeholder="Selecteer een datum"
        [value]="externalSupplierAware.extraSupplierDeadline"
        (dateChange)="extraSupplierDeadlineChange($event)"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="extraSupplierDeadlinePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #extraSupplierDeadlinePicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>

<yes-no
  [title]="'Extra materialen nodig'"
  [value]="externalSupplierAware.needExtraMaterials"
  [nullable]="true"
  [nullIsFalse]="false"
  [done]="externalSupplierAware.needExtraMaterialsDone"
  [inputText]="externalSupplierAware.extraInfoNeedExtraMaterials"
  [extraInstructions]="'Geef meer informatie aub'"
  (answer)="needExtraMaterialsChange($event)"
  (answeredText)="extraInfoNeedExtraMaterialsChange($event)"
  (doneAnswered)="needExtraMaterialsDoneChange($event)"
>
</yes-no>

<div
  *ngIf="externalSupplierAware.needExtraMaterials"
  class="d-flex external-supplier-employee-date"
>
  <div>
    <div class="form-sub-title">Medewerker</div>

    <mat-form-field class="" appearance="outline">
      <mat-select
        matInput
        placeholder="Maak een keuze"
        name="extraMaterialsEmployee"
        required
        [(ngModel)]="externalSupplierAware.extraMaterialsEmployee"
        (ngModelChange)="extraMaterialsEmployeeChange()"
        [compareWith]="compareEntities"
      >
        <mat-option *ngFor="let option of employeeChoices" [value]="option">
          {{ option.user.firstName }} {{ option.user.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="left-space">
    <div class="form-sub-title">Deadline</div>
    <mat-form-field appearance="outline">
      <input
        #extraMaterialsDeadlineInput
        matInput
        [matDatepicker]="extraMaterialsDeadlinePicker"
        placeholder="Selecteer een datum"
        [value]="externalSupplierAware.extraMaterialsDeadline"
        (dateChange)="extraMaterialsDeadlineChange($event)"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="extraMaterialsDeadlinePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #extraMaterialsDeadlinePicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
